// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__22eYK","chart":"chart__g0EBG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/GatewayView/coms/PieChart/styles.scss
// module id = 2295
// module chunks = 1